<template>
  <div class="gestion-cita-container container my-5 py-5 text-center">
    <div
      v-if="loading"
      class="py-5"
    >
      <font-awesome-icon
        icon="circle-notch"
        class="fa-spin fa-4x text-primary mb-3"
      />
      <h3 class="h4 text-muted">
        Procesando tu solicitud...
      </h3>
    </div>

    <div
      v-else
      class="card mx-auto p-4 shadow-sm"
      style="max-width: 550px; border-radius: 12px;"
    >
      <div v-if="result.success">
        <div class="my-3">
          <font-awesome-icon
            :icon="getIconByCode(result.code)"
            :class="getIconClassByCode(result.code)"
            class="fa-5x"
          />
        </div>
        <h2
          class="h3 font-weight-bold mb-3"
          :class="getTitleClassByCode(result.code)"
        >
          {{ getTitleByCode(result.code, true) }}
        </h2>
        <p class="lead text-dark mb-4">
          {{ result.message }}
        </p>
      </div>

      <div v-else>
        <div class="my-3">
          <font-awesome-icon
            :icon="getIconByCode(result.code)"
            :class="getIconClassByCode(result.code)"
            class="fa-5x"
          />
        </div>
        <h2
          class="h3 font-weight-bold mb-3"
          :class="getTitleClassByCode(result.code)"
        >
          {{ getTitleByCode(result.code, false) }}
        </h2>
        <p class="lead text-muted mb-4">
          {{ result.message
            || 'Ocurrió un error inesperado al procesar tu solicitud.' }}
        </p>
      </div>

      <hr class="my-4">

      <div>
        <p class="small text-muted mb-3">
          Puedes gestionar tus citas y tratamientos con tu cuenta de AMII.
        </p>
        <router-link
          to="/"
          class="btn btn-primary px-4 py-2 font-weight-bold"
          style="border-radius: 20px;"
        >
          Ir al Inicio
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag';

const PROCESS_ACTION_MUTATION = gql`
  mutation processAppointmentAction($token: String!) {
    processAppointmentAction(token: $token) {
      success
      message
      status
      appointmentId
      code
    }
  }
`;

export default {
  name: 'GestionCita',
  data() {
    return {
      loading: true,
      result: {
        success: false,
        message: '',
        status: null,
        code: null,
      },
    };
  },
  mounted() {
    const token = this.$route.params.token;
    if (!token) {
      this.loading = false;
      this.result = {
        success: false,
        message: 'No se proporcionó ningún código o token válido.',
        status: null,
      };
      return;
    }

    this.$apollo
        .mutate({
          mutation: PROCESS_ACTION_MUTATION,
          variables: {token},
        })
        .then((res) => {
          const data = res.data && res.data.processAppointmentAction;
          if (data) {
            this.result = data;
          } else {
            this.result = {
              success: false,
              message: 'Error en la respuesta de confirmación de cita.',
              status: null,
            };
          }
        })
        .catch((err) => {
          console.error('Error al procesar acción de cita:', err);
          this.result = {
            success: false,
            message: 'Ocurrió un error al enviar la respuesta. '
            + 'Inténtalo más tarde o contacta al consultorio.',
            status: null,
          };
        })
        .finally(() => {
          this.loading = false;
        });
  },
  methods: {
    getIconByCode(code) {
      switch (code) {
        case 'confirmed':
        case 'already_confirmed':
        case 'reassigned':
          return 'check-circle';
        case 'already_taken_renotified':
          return 'paper-plane';
        case 'already_taken':
        case 'cancelled':
        case 'already_cancelled':
          return 'info-circle';
        case 'expired_token':
          return 'clock';
        case 'invalid_token':
        case 'server_error':
        default:
          return 'exclamation-triangle';
      }
    },
    getIconClassByCode(code) {
      switch (code) {
        case 'confirmed':
        case 'reassigned':
          return 'text-success';
        case 'already_confirmed':
        case 'already_taken_renotified':
          return 'text-primary';
        case 'cancelled':
        case 'already_cancelled':
        case 'already_taken':
          return 'text-warning';
        case 'expired_token':
        case 'invalid_token':
        case 'server_error':
        default:
          return 'text-danger';
      }
    },
    getTitleByCode(code, defaultSuccess) {
      switch (code) {
        case 'confirmed':
          return '¡Cita Confirmada!';
        case 'already_confirmed':
          return 'Cita Ya Confirmada';
        case 'reassigned':
          return '¡Cita Adelantada y Confirmada!';
        case 'already_taken_renotified':
          return 'Cupo Asignado - Nuevo Correo Enviado';
        case 'already_taken':
          return 'Cupo No Disponible';
        case 'cancelled':
          return 'Cita Cancelada';
        case 'already_cancelled':
          return 'Cita Ya Cancelada';
        case 'expired_token':
          return 'Enlace Expirado';
        case 'invalid_token':
          return 'Enlace Inválido';
        default:
          return defaultSuccess
            ? '¡Solicitud Procesada!'
            : 'No se pudo procesar la solicitud';
      }
    },
    getTitleClassByCode(code) {
      switch (code) {
        case 'confirmed':
        case 'reassigned':
          return 'text-success';
        case 'already_confirmed':
        case 'already_taken_renotified':
          return 'text-primary';
        case 'cancelled':
        case 'already_cancelled':
        case 'already_taken':
          return 'text-warning';
        default:
          return 'text-danger';
      }
    },
  },
};
</script>

<style scoped>
.gestion-cita-container {
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
